import FormText from 'components/form/FormText';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SettingCompanyFormStateType } from '../hooks/useSettingCompany';

import type { JSX } from 'react';

type Props = {
  register: UseFormRegister<SettingCompanyFormStateType>;
  errors: FieldErrors<SettingCompanyFormStateType>;
  isAdmin: boolean;
};

/**
 * カンパニー設定 - プライバシーポリシー / コピーライトセクション
 */
export default function PrivacyCopyrightSection({ register, errors, isAdmin }: Props): JSX.Element {
  return (
    <div className="form-group">
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="プライバシーポリシーのURL"
            name="privacyPolicyUrl"
            placeholder="http://example.com/plivacypolicy"
            register={register}
            errors={errors}
            maxLength={100}
            requiredMark={true}
            format="url"
            required={true}
            readOnly={!isAdmin}
          />
          <p className="mt-1">プライバシーポリシーが記載されたページのURLを記入してください</p>
        </div>
        <div className="column col-lg-6 col-xl-6 col-right">
          <FormText
            subject="コピーライトの設定"
            name="copyright"
            placeholder="©株式会社サンプル"
            register={register}
            errors={errors}
            maxLength={100}
            required={true}
            requiredMark={true}
            readOnly={!isAdmin}
          />
        </div>
      </div>
    </div>
  );
}
